<template>
    <section class="main">
        <div v-show="isObjectLoading">
            <v-page-loading />
        </div>
        <div v-show="!isObjectLoading">
            <v-page-header :title="isViewMethod ? $t('account.profile.email') : $t('account.profile.email.update')" />
            <v-form-message id="form-error" :message="objectError" type="error" :isVisible="objectError !== null" />
            <v-form-message id="form-success" :message="objectSuccess" type="success" :isVisible="objectSuccess !== null" />

            <div class="grid-container">
                <div class="grid-x">
                    <div class="cell medium-9 medium-offset-1 large-11 large-offset-0">
                        <v-action-buttons :items="getActionButtons" :isDisabled="objectFormDisabled" @actionClicked="onClickAction" />

                        <div class="box">
                            <div class="form-block">
                                <div v-if="isViewMethod" class="form-group">
                                    <label>{{ $t('form.email') }}</label>
                                    <div class="form-control form-control--static">
                                        {{ object.email }}
                                    </div>
                                </div>
                                <div v-else class="form-group" :class="{ 'form-group--error' : $v.object.email.$error, 'form-group--required' : $v.object.email.$params.required }">
                                    <label for="form-field-email">{{ $t('form.email') }}</label>
                                    <input type="text" id="form-field-email" name="email" v-model="$v.object.email.$model" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import PageHeader from '../partials/PageHeader';
    import PageLoading from '../partials/PageLoading';
    import ActionButtons from './../partials/Foundation/ActionButtons';
    import FormMessage from './../partials/Forms/FormMessage';
    import { required, email } from 'vuelidate/lib/validators';

    export default {
        data() {
            return {
                objectLoading           : false,
                objectError             : null,
                objectSuccess           : null,
                objectFormDisabled      : false,
                object                  : {
                    id                      : 0,
                    email                   : ''
                }
            }
        },
        components : {
            vPageHeader         : PageHeader,
            vPageLoading        : PageLoading,
            vActionButtons      : ActionButtons,
            vFormMessage        : FormMessage
        },
        computed : {
            isViewMethod : function () {
                return this.$route.meta.method === 'view';
            },
            isUpdateMethod : function () {
                return this.$route.meta.method === 'update';
            },
            isObjectLoading : function () {
                return this.objectLoading;
            },
            getActionButtons : function () {
                var buttons = [];

                if (this.isViewMethod) {
                    buttons.push({
                        action  : 'update',
                        router  : { name : 'account-update-email' }
                    });
                }

                if (this.isUpdateMethod) {
                    buttons.push('save', {
                        action  : 'cancel',
                        router  : {name: 'account-view-email'}
                    });
                }

                return buttons;
            }
        },
        created : function () {
            this.onUpdateObject();
        },
        validations : function () {
            return {
                object      : {
                    email       : {
                        required,
                        email
                    }
                }
            };
        },
        methods : {
            onClickAction : function (action) {
                switch (action) {
                    case 'save':
                        this.onSubmitObject();

                        break;
                }
            },
            onUpdateObject : function () {
                let promise = this.$api.clearParams()
                    .userGetAccount();

                promise.then((response => {
                    this.object.id      = response.data.data.id;
                    this.object.email   = response.data.data.profile.communication.email;
                }).bind(this)).catch((error => {
                    console.log(error);
                }).bind(this)).finally((() => {
                    this.objectLoading = false;
                }).bind(this));

                this.objectLoading = true;
            },
            onSubmitObject : function () {
                this.objectError        = null;
                this.objectSuccess      = null;
                this.objectFormDisabled = true;

                this.$v.object.$touch();

                if (this.$v.object.$invalid) {
                    this.objectError        = this.$t('form.error_form');
                    this.objectFormDisabled = false;
                } else {
                    let promise = this.$api.clearParams()
                        .post('accounts/me/change-mail', this.object);

                    promise.then((response => {
                        this.objectSuccess      = this.$t('account.profile.email.update.success');
                    }).bind(this)).catch((error => {
                        this.objectError        = this.$t(error.response.data.message);
                    }).bind(this)).finally((() => {
                        this.objectFormDisabled = false;
                    }).bind(this));
                }
            }
        }
    }
</script>